export const data = {
  items: {
    itemType: 'string',
    item: {
      engine: {
        id: 0,
        displayName: 'string',
        refNo: 'string',
        isSold: true,
        isKanazawaLocation: true,
        makerId: 0,
        makerName: 'string',
        productClassCategoryId: 0,
        productClassName: 'string',
        productCategoryId: 'string',
        productName: 'string',
        Images: ['string'],
        movie: 'string',
        createdAt: 0,
        updatedAt: 0,
        favoriteId: 0,
        tags: [
          {
            id: 0,
            name: 'string',
          },
        ],
        dismantleFee: 'string',
        withCatalystPrice: 'string',
        withoutCatalystPrice: 'string',
        carName: 'string',
        carModel: 'string',
        modelCode: 'string',
        engineModel: 'string',
        year: 'string',
        transmission: 'string',
        mileage: 'string',
        chassisNo: 'string',
        steering: 'string',
        missionModel: 'string',
        fuelType: 'string',
        displacement: 'string',
        exportCertificate: 'string',
        location: 'string',
        remarks: 'string',
        tlimNo: 'string',
        stockType: 'string',
      },
      part: {
        id: 0,
        displayName: 'string',
        refNo: 'string',
        isSold: true,
        isKanazawaLocation: true,
        makerId: 0,
        makerName: 'string',
        productClassCategoryId: 0,
        productClassName: 'string',
        productCategoryId: 'string',
        productName: 'string',
        Images: ['string'],
        movie: 'string',
        createdAt: 0,
        updatedAt: 0,
        favoriteId: 0,
        tags: [
          {
            id: 0,
            name: 'string',
          },
        ],
        originalPrice: 'string',
        dismantleFee: 'string',
        wrappingFee: 'string',
        carName: 'string',
        carModel: 'string',
        modelCode: 'string',
        engineModel: 'string',
        year: 'string',
        transmission: 'string',
        mileage: 'string',
        chassisNo: 'string',
        steering: 'string',
        missionModel: 'string',
        fuelType: 'string',
        displacement: 'string',
        exportCertificate: 'string',
        location: 'string',
        remarks: 'string',
        tlimNo: 'string',
        stockType: 'string',
      },
      ckdCar: {
        id: 0,
        displayName: 'string',
        refNo: 'string',
        isSold: true,
        isKanazawaLocation: true,
        makerId: 0,
        makerName: 'string',
        productClassCategoryId: 0,
        productClassName: 'string',
        productCategoryId: 'string',
        productName: 'string',
        Images: ['string'],
        movie: 'string',
        createdAt: 0,
        updatedAt: 0,
        favoriteId: 0,
        tags: [
          {
            id: 0,
            name: 'string',
          },
        ],
        originalPrice: 'string',
        dismantleFee: 'string',
        wrappingFee: 'string',
        carName: 'string',
        carModel: 'string',
        modelCode: 'string',
        engineModel: 'string',
        year: 'string',
        transmission: 'string',
        mileage: 'string',
        chassisNo: 'string',
        steering: 'string',
        missionModel: 'string',
        fuelType: 'string',
        displacement: 'string',
        exportCertificate: 'string',
        location: 'string',
        remarks: 'string',
        tlimNo: 'string',
        tireWheel: true,
        navigation: true,
        strut: true,
        spareTire: true,
        genuineFloorMat: true,
        trunkMat: true,
        tonneauCover: true,
        stockType: 'string',
      },
      ybCar: {
        id: 0,
        displayName: 'string',
        refNo: 'string',
        isSold: true,
        isKanazawaLocation: true,
        makerId: 0,
        makerName: 'string',
        productClassCategoryId: 0,
        productClassName: 'string',
        productCategoryId: 'string',
        productName: 'string',
        Images: ['string'],
        movie: 'string',
        createdAt: 0,
        updatedAt: 0,
        favoriteId: 0,
        tags: [
          {
            id: 0,
            name: 'string',
          },
        ],
        carName: 'string',
        carModel: 'string',
        modelCode: 'string',
        engineModel: 'string',
        year: 'string',
        transmission: 'string',
        mileage: 'string',
        chassisNo: 'string',
        steering: 'string',
        missionModel: 'string',
        fuelType: 'string',
        displacement: 'string',
        exportCertificate: 'string',
        location: 'string',
        remarks: 'string',
        stockType: 'string',
        parts: {
          sample: 'string',
        },
      },
    },
    options: [
      {
        optionCategory: 'string',
        optionId: 'string',
        optionName: 'string',
      },
    ],
    planParts: [
      {
        itemName: 'Front seats',
        orderName: 'string',
        status: 'string',
      },
      {
        itemName: 'Nose cut',
        orderName: 'string',
        status: 'string',
      },
      {
        itemName: 'Engine ECU harness',
        orderName: 'string',
        status: 'string',
      },
      {
        itemName: 'Engine member',
        orderName: 'string',
        status: 'string',
      },
      {
        itemName: 'Fuse box',
        orderName: 'string',
        status: 'string',
      },
      {
        itemName: 'Meter',
        orderName: 'string',
        status: 'string',
      },
      {
        itemName: 'Rear bumper',
        orderName: 'string',
        status: 'string',
      },
      {
        itemName: 'Drive shaft',
        orderName: 'string',
        status: 'string',
      },
      {
        itemName: 'Strut assy',
        orderName: 'string',
        status: 'string',
      },
      {
        itemName: 'Rear seats(all)',
        orderName: 'string',
        status: 'string',
      },
      {
        itemName: 'Bonnet',
        orderName: 'string',
        status: 'string',
      },
      {
        itemName: 'Master break',
        orderName: 'string',
        status: 'string',
      },

      {
        itemName: 'All doors',
        orderName: 'string',
        status: 'string',
      },
      {
        itemName: 'Tail lights',
        orderName: 'string',
        status: 'string',
      },
      {
        itemName: 'Air cleaner',
        orderName: 'string',
        status: 'string',
      },
      {
        itemName: 'Lower arm',
        orderName: 'string',
        status: 'string',
      },

      {
        itemName: 'Blower motor',
        orderName: 'string',
        status: 'string',
      },
      {
        itemName: 'Muffler',
        orderName: 'string',
        status: 'string',
      },
    ],
    extraParts: [
      {
        itemName: 'ABS unit',
        orderName: 'string',
        status: '',
      },
      {
        itemName: 'Console box',
        orderName: 'string',
        status: '1',
      },
      {
        itemName: 'Dash board',
        orderName: 'string',
        status: '',
      },
      {
        itemName: 'Engine mount',
        orderName: 'string',
        status: '',
      },
      {
        itemName: 'Evaporator',
        orderName: 'string',
        status: '1',
      },
    ],
    status: false,
  },
}
